import React from "react";
import styled from "styled-components";
import { CircleNo1Src, CircleNo2Src, CircleNo3Src } from "../../../resources/Assets";

export default (props) => {
  return (
    <div style={{ width: "100%" }}>
      <ListContainer>
        <TextDiv>
          <div>
            <TextTopic style={{ marginBottom: "16px" }}>아래 데이터가 통합됩니다</TextTopic>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img src={CircleNo1Src} style={{ width: "20px", height: "20px" }} />
                <TextP>자가건강관리정보 (혈압, 혈당 등)</TextP>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img src={CircleNo2Src} style={{ width: "20px", height: "20px" }} />
                <TextP>진료이력 · 교육자료</TextP>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img src={CircleNo3Src} style={{ width: "20px", height: "20px" }} />
                <TextP>병원연동정보</TextP>
              </div>
            </div>
          </div>
        </TextDiv>
      </ListContainer>
    </div>
  );
};

export const ListContainer = styled.div`
  margin: 40px 15px 0px 15px;
`;

const TextDiv = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 6px;
  background: #fafafa;
`;

const TextTopic = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const TextP = styled.div`
  color: #898989;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
